<template>
  <div class="error">{{text}}</div>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="scss" scoped>
.error {
  border-radius: 5px;
  color: #fff;
  background: #f66d6d;
  font-size: 17px;
  padding: 10px;
  text-align: center;
  margin-top: 15px;
}
</style>